const ICONS = {
    arrowBack: require('../assets/icons/arrow_back.png'),
    google: require('../assets/icons/google.png'),
    apple: require('../assets/icons/apple.png'),
    home: require('../assets/icons/home.png'),
    studio: require('../assets/icons/studio.png'),
    store: require('../assets/icons/store.png'),
    chat: require('../assets/icons/chat.png'),
    jobs: require('../assets/icons/jobs.png'),
    profile: require('../assets/icons/profile.png'),
    gear: require('../assets/icons/gear.png'),
    upload: require('../assets/icons/upload.png'),
    editProfileSettings: require('../assets/icons/edit-profile-settings.png'),
    paint: require('../assets/icons/paint.png'),
    notification: require('../assets/icons/notification.png'),
    lock: require('../assets/icons/lock.png'),
    creditCard: require('../assets/icons/credit-card.png'),
    questionMark: require('../assets/icons/question-mark.png'),
    letterI: require('../assets/icons/letter-i.png'),

}

export {
    ICONS
}